import React from "react";

interface Props {
    register: any
    name: string
    value: string
}

function F006HiddenField(props: Props) {
    return <input key={props.name} type="hidden" value={props.value} {...props.register(props.name)}/>
}

export default F006HiddenField